import * as React from "react";
import { CategoryWrapper, CategoryBox, ControllerArrow, CategoryFloatWrapper } from "./styles";
import { isNotBlankArray } from "../../../../utils/array";
const activeTabStyle = (lightColor = "#fff", backgroundColor = "#ff5a00") => {
    return {
        color: lightColor,
        backgroundColor,
    };
};
const defaultTabStyle = (color = "#333") => {
    return {
        color,
    };
};
class ProductTag extends React.Component {
    constructor(props) {
        super(props);
        this.handelClickItem = (item, index) => () => {
            this.props.onChange(item, index, this.props.fixed);
        };
        this.getListStyle = (item, nextActiveTab = "") => {
            const { activeTabIndex } = this.props;
            let isAcitve = item.id === nextActiveTab;
            if (activeTabIndex) {
                isAcitve = item.positionId === `${nextActiveTab}|${activeTabIndex}`;
            }
            return isAcitve
                ? activeTabStyle(item.text.lightColor, item.focusBgColor)
                : defaultTabStyle(item.text.color);
        };
        this.state = {
            expanded: props.hasExpand,
        };
    }
    render() {
        var _a;
        const { tagGroup, activeTab = (_a = tagGroup === null || tagGroup === void 0 ? void 0 : tagGroup[0]) === null || _a === void 0 ? void 0 : _a.id, hasExpand } = this.props;
        const { expanded } = this.state;
        const expanded1 = expanded !== undefined ? expanded : hasExpand;
        return (React.createElement(CategoryBox, { width: this.props.width, hasExpand: hasExpand, expanded: expanded1 },
            tagGroup.map((item, index) => (React.createElement("li", { key: index, "data-id": item.id, onClick: this.handelClickItem(item, index), style: this.getListStyle(item, `${activeTab}`) || {} }, item.text.content))),
            hasExpand && (React.createElement(ControllerArrow, { onClick: () => this.setState({ expanded: !expanded1 }), className: expanded1 ? "arrowUp" : "arrowDown" }))));
    }
}
class ProductTags extends React.Component {
    constructor(props) {
        super(props);
        this.navWrapRef = React.createRef();
        this.placeholderRef = React.createRef();
        this.onScroll = () => {
            const { stickToTop } = this.props;
            if (!this.navWrapRef || !this.placeholderRef) {
                return;
            }
            const navWrapCurrent = this.navWrapRef.current;
            const placeHolderCurrent = this.placeholderRef.current;
            let navToTop = navWrapCurrent.getBoundingClientRect().top;
            let parentNode = navWrapCurrent.parentNode;
            let parentToBottom = parentNode.getBoundingClientRect().bottom;
            if (this.state.fixed) {
                if (placeHolderCurrent.getBoundingClientRect().top >= stickToTop ||
                    parentToBottom <= stickToTop) {
                    this.setState({ fixed: false });
                }
                return;
            }
            if (navToTop <= stickToTop && parentToBottom > stickToTop && !this.state.fixed) {
                this.setState({ fixed: true });
            }
        };
        this.state = {
            fixed: false,
        };
    }
    componentDidMount() {
        const { canScrollFixed } = this.props;
        if (canScrollFixed) {
            window.addEventListener("scroll", this.onScroll);
        }
    }
    componentWillUnmount() {
        window.removeEventListener("scroll", this.onScroll);
    }
    shouldComponentUpdate(...updateProps) {
        const preState = updateProps[1];
        if ((preState === null || preState === void 0 ? void 0 : preState.fixed) && this.state.fixed) {
            return false;
        }
        return true;
    }
    render() {
        const { fixed } = this.state;
        const { tagGroup = [], stickToTop = 0 } = this.props;
        if (!isNotBlankArray(tagGroup)) {
            return null;
        }
        const ProductTag1 = React.forwardRef((props, ref) => {
            var _a, _b;
            return (React.createElement(CategoryWrapper, Object.assign({ ref: ref }, props, { style: {
                    backgroundColor: ((_a = tagGroup[0]) === null || _a === void 0 ? void 0 : _a.bgColor) || "#fff",
                } }),
                React.createElement(ProductTag, Object.assign({}, this.props, { fixed: false, hasExpand: !!((_b = tagGroup[0]) === null || _b === void 0 ? void 0 : _b.tabExpand) }))));
        });
        const ProductTag2 = React.forwardRef((props, ref) => {
            var _a, _b;
            return (React.createElement(CategoryFloatWrapper, Object.assign({ ref: ref }, props, { isFixed: fixed, scrollTop: stickToTop, style: {
                    backgroundColor: ((_a = tagGroup[0]) === null || _a === void 0 ? void 0 : _a.bgColor) || "#fff",
                } }), fixed && (React.createElement(ProductTag, Object.assign({}, this.props, { fixed: fixed, hasExpand: !!((_b = tagGroup[0]) === null || _b === void 0 ? void 0 : _b.tabExpand) })))));
        });
        return (React.createElement(React.Fragment, { key: `${this.props.activeTab}_${tagGroup === null || tagGroup === void 0 ? void 0 : tagGroup.length}_${fixed}` },
            React.createElement(ProductTag1, { key: `placeholder_${this.props.activeTab}_${tagGroup === null || tagGroup === void 0 ? void 0 : tagGroup.length}`, ref: this.placeholderRef }),
            React.createElement(ProductTag2, { key: `category_${this.props.activeTab}_${tagGroup === null || tagGroup === void 0 ? void 0 : tagGroup.length}`, ref: this.navWrapRef })));
    }
}
ProductTags.defaultProps = {
    canScrollFixed: true,
    stickToTop: 0,
};
export default ProductTags;
